import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LendingHeroSection from './components/LendingHeroSection';
import LendingRecommendedSection from './components/LendingRecommendedSection';
import LendingSafetySection from './components/LendingSafetySection';
import LendingAboutSection from './components/LendingAboutSection';
import LendingRatesSection from './components/LendingRatesSection';
import LendingPlansSection from './components/LendingPlansSection';
import LendingHowItWorksSection from './components/LendingHowItWorksSection';
import LendingComparisonSection from './components/LendingComparisonSection';
import LendingSecuritySection from './components/LendingSecuritySection';
import LendingStepsSection from './components/LendingStepsSection';
import LendingFAQSection from './components/LendingFAQSection';
import LendingCTASection from './components/LendingCTASection';

export default function LendingPage() {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main>
        <LendingHeroSection />
        <LendingRecommendedSection />
        <LendingSafetySection />
        <LendingAboutSection />
        <LendingRatesSection />
        <LendingPlansSection />
        <LendingHowItWorksSection />
        <LendingComparisonSection />
        <LendingSecuritySection />
        <LendingStepsSection />
        <LendingFAQSection />
        <LendingCTASection />
      </main>
      <Footer />
    </div>
  );
}
